/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface OtherUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  profileImage: string | null;
}

export interface ConversationItem {
  id: string;
  otherUser: OtherUser;
  lastMessage: string | null;
  lastMessageAt: string | null;
  unreadCount: number;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface ConversationsResponse {
  data: ConversationItem[];
  pagination: Pagination;
}

const fetchConversationsRequest = async (
  page = 1,
  limit = 20
): Promise<ConversationsResponse> =>
  (
    await customAxios.get<ConversationsResponse>(
      `/chat/conversations?page=${page}&limit=${limit}`
    )
  ).data;

export const useGetConversations = (page = 1, limit = 20) =>
  useQuery<ConversationsResponse, AxiosError>(
    ["conversations", page, limit],
    () => fetchConversationsRequest(page, limit),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Conversations",
          message:
            (error.response?.data as { message?: string })?.message ||
            "Failed to load conversations",
          color: "red",
        }),
      retry: 1,
      refetchOnMount: "always",
      staleTime: 0,
    }
  );
